export default __webpack_public_path__ + "static/media/small.155083f7.jpg";